export const getCharacterCountWithoutHTML = (text) => {
  if (text !== null) {
    const regex = /(<([^>]+)>)/ig;
    // text editor replaces < and > within text with &lt; and &gt; respectively
    // hence undoing it to get the length
    const textWithoutHTML = text.replace(regex, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
    return textWithoutHTML.length;
  }
  return 0;
}
